import { Component, DestroyRef, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart } from '@angular/router';
import { filter } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { AreaAyuda, areaAyudaDeRuta } from '@app/core/services/ayuda-accesos.service';

@Component({
    selector: 'app-ayuda-shortcut',
    standalone: true,
    imports: [RouterLink, DialogModule],
    templateUrl: './ayuda-shortcut.component.html',
    styleUrl: './ayuda-shortcut.component.scss'
})
export class AyudaShortcutComponent {
    readonly router = inject(Router);
    visible = false;
    oculto = false;
    area: AreaAyuda = 'sistema';

    constructor() {
        this.router.events.pipe(
            filter((event) => event instanceof NavigationStart),
            takeUntilDestroyed(inject(DestroyRef))
        ).subscribe(() => this.visible = false);
    }

    abrir(): void {
        this.area = areaAyudaDeRuta(this.router.url);
        this.visible = true;
    }

    ocultar(): void {
        this.visible = false;
        this.oculto = true;
    }
}
